import { Component, Input } from '@angular/core';
import { ErrorMessage } from 'src/app/core/models/error-message.model';
import { Util } from 'src/app/shared/utils/util';

@Component({
  selector: 'app-alert-custom',
  templateUrl: './alert-custom.component.html'
})
export class AlertCustomComponent {

  @Input() error = new ErrorMessage();
  @Input() fontBigger: boolean;

  private typeErrorMap: { [key: string]: string } = {
    'danger': 'alert-danger',
    'success': 'alert-success',
    'info': 'alert-info',
    'warning': 'alert-warning',
    'dark': 'alert-dark'
  }

  closeAlert() {
    Util.clearErrorMessage(this.error);
  }


  typeError() {
    return this.typeErrorMap[this.error.errorType] || 'alert-dark';
  }

  setFontSize() {
    if (this.fontBigger) {
      return 'bigger';
    }
    return '';
  }

}
